import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

function calculateValue(value, step, min) {
    if (value - min < 0) {
        return min;
    }
    if (value % step === 0) {
        return value;
    }
    return (Math.floor(value / step) + 1) * step;
}

export default class StepperController extends React.Component {
    constructor(props) {
        super(props);

        this.state = { value: this.props.value };
    }

    componentWillUpdate(nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
        }
    }

    onInputChange(event) {
        event.preventDefault();
        if (event.target.value !== "") {
            const value = parseInt(event.target.value, 10);
            this.setState({ value });
            this.props.onChange(value || this.props.min);
        }
    }

    onInputBlur(event) {
        event.preventDefault();
        if (event.target.value !== "") {
            const value = parseInt(event.target.value, 10);
            if (value !== this.props.min && value % (this.props.step) !== 0) {
                this.props.onChange(calculateValue(value, this.props.step, this.props.min));
            }
        }
    }

    onDecrease(event) {
        event.preventDefault();
        const value = parseInt(this.state.value, 10);
        if (value - this.props.step <= this.props.min) {
            this.props.onChange(this.props.min);
        } else {
            this.props.onChange(calculateValue(value - this.props.step, this.props.step, this.props.min));
        }
    }

    onIncrease(event) {
        event.preventDefault();
        const value = parseInt(this.state.value, 10);
        if (this.props.min % this.props.step !== 0 && this.props.min === value) {
            this.props.onChange(this.props.step);
        } else {
            this.props.onChange(calculateValue(value + this.props.step, this.props.step, this.props.min));
        }
    }

    render() {
        const StepperView = ComponentRegistry.get(this.props.view);

        return (
          <StepperView
            value={parseInt(this.state.value, 10)}
            onInputChange={event => this.onInputChange(event)}
            onInputBlur={event => this.onInputBlur(event)}
            onDecrease={event => this.onDecrease(event)}
            onIncrease={event => this.onIncrease(event)}
            label={this.props.value > 1 ? this.props.labels.multiple : this.props.labels.single}
          />
        );
    }
}

StepperController.propTypes = {
    view: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    labels: PropTypes.shape({
        single: PropTypes.string,
        multiple: PropTypes.string,
    }).isRequired,
    step: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

StepperController.defaultProps = {
    value: 1,
    view: "CommonStepperView",
    step: 1,
    min: 1,
    labels: {
        single: "Item",
        multiple: "Items",
    },
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Controllers/StepperController.jsx